/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const n=Symbol("isAnnotationFeatureGraphicOrigin");function i(i){return!!i&&n in i}export{i as isAnnotationFeatureGraphicOrigin,n as isAnnotationFeatureGraphicOriginSymbol};
